<template>
  <div>
    <h1
      class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase"
    >{{ $t('requests.requests') }}</h1>
    <loader v-if="loading"></loader>
  <div v-if="session.startup_application"> 
    <div
      v-if="this.session.startup_application.status  == 12 && !loading"
      class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
    >{{ $t('form.label_inactive') }}</div>

    <div v-if="requests">
      <div class="flex flex-col mt-8">
        <div class="inline-flex">
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.name_project') }} :</div>
          <div class="flex-1 px-4 py-2 m-2">{{requests.detail.project_name}}</div>
        </div>
        <div class="inline-flex">
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.number_label') }} :</div>

          <div
            class="flex-1 px-4 py-2 m-2 font-semibold"
            :class="{
              'text-red': this.session.startup_application.status  != 12,
              'text-grey-lighter': this.session.startup_application.status  == 12
              }"
          >{{requests.detail.label_ref}}</div>
        </div>
        <div class="inline-flex">
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.submitted') }} :</div>
          <div
            class="flex-1 px-4 py-2 m-2"
          >{{new Date(requests.detail.published_at)| dateFormat('DD/MM/YYYY HH:mm')}}</div>
        </div>
        <div class="inline-flex" v-if="requests.detail.label_date">
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.date_label') }} :</div>
          <div
            class="flex-1 px-4 py-2 m-2"
          >{{new Date(requests.detail.label_date)| dateFormat('DD/MM/YYYY')}}</div>
        </div>
        <div class="inline-flex" v-if="requests.detail.scan_label">
          <div class="flex-1 px-4 py-2 m-2">
            <a
              :href="requests.detail.scan_label"
              target="_blank"
              class="font-semibold text-red"
            >{{ $t('requests.scan_label') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
    
    <div v-if="PrelabelData && PrelabelData.application.type == 'Prélabel'">
      <div
        v-if="PrelabelData.application.label_ref==null && PrelabelData.application.request_label_date !=null"
        class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
      >{{ $t('requests.success_label') }} {{new Date(PrelabelData.application.request_label_date)| dateFormat('DD/MM/YYYY HH:mm')}}</div>
      <div class="flex flex-col mt-8">
        <div class="inline-flex">
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.name_project') }} :</div>
          <div class="flex-1 px-4 py-2 m-2">{{PrelabelData.application.project_name}}</div>
        </div>
        <div class="inline-flex" v-if="PrelabelData.application.label_ref!=null">
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.number_label') }} :</div>
          <div
            class="flex-1 px-4 py-2 m-2 font-semibold text-red"
          >{{PrelabelData.application.label_ref}}</div>
        </div>
        <div class="inline-flex" v-if="PrelabelData.application.published_at!=null">
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.submitted') }} :</div>
          <div
            class="flex-1 px-4 py-2 m-2"
          >{{new Date(PrelabelData.application.published_at)| dateFormat('DD/MM/YYYY HH:mm')}}</div>
        </div>
        <div class="inline-flex" v-if="PrelabelData.application.label_created_at">
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.date_label') }} :</div>
          <div
            class="flex-1 px-4 py-2 m-2"
          >{{new Date(PrelabelData.application.label_created_at)| dateFormat('DD/MM/YYYY')}}</div>
        </div>
        <div class="inline-flex" v-if="PrelabelData.application.scan_label!=null">
          <div class="flex-1 px-4 py-2 m-2">
            <a
              :href="PrelabelData.application.scan_label"
              target="_blank"
              class="font-semibold text-red"
            >{{ $t('requests.scan_label') }}</a>
          </div>
        </div>
        <div
          class="inline-flex"
          v-if="PrelabelData.application.label_ref==null && PrelabelData.application.prelabel_created_at != null"
        >
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.date_prelabel') }} :</div>
          <div
            class="flex-1 px-4 py-2 m-2"
          >{{new Date(PrelabelData.application.prelabel_created_at)| dateFormat('DD/MM/YYYY')}}</div>
        </div>
        <div
          class="inline-flex"
          v-if="PrelabelData.application.label_ref==null && PrelabelData.application.request_label_date==null && PrelabelData.application.date_apply"
        >
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.deadline_demande_label') }} :</div>
          <div
            class="flex-1 px-4 py-2 m-2"
          >{{new Date(PrelabelData.application.date_apply)| dateFormat('DD/MM/YYYY')}}</div>
        </div>
        <div
          class="inline-flex"
          v-if="PrelabelData.application.can_request && PrelabelData.application.request_label_date==null && session.startup_application.user_id == session.user_auth.id &&  PrelabelData.application.can_apply == true"
        >
          <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.created_company') }}</div>
          <div class="flex-1" v-if="isFutureDate(PrelabelData.application.date_apply)">
            <sp-button 
              theme="outline-blue"
              space="small"
              @click="applyRequest(5)"
              type="submit"
              class="ml-0"
            >{{ $t('requests.finalize_label_request') }}</sp-button>
          </div>
        </div>
        <div class="text-red my-2 leading-loose font-semibold flex-1 px-4 py-2 m-2" v-else>
          Sauf le lead peut faire la demande de passage et non pas les membres
        </div>
        <div
          class="inline-flex"
          v-if="PrelabelData.application.status == '9' &&
            !PrelabelData.application.can_request"
        >
          <div class="flex-1 px-4 py-2 m-2">Demande de passage de pré-label à Label</div>
          <div class="flex-1">
            <sp-button
              v-if="PrelabelData.application.request_status == '4'"
              theme="outline-blue"
              space="small"
              @click="edit()"
              type="submit"
              class="ml-0"
            >{{ $t('requests.edit') }}</sp-button>
            <sp-button
              v-else
              theme="outline-blue"
              space="small"
              @click="show()"
              type="submit"
              class="ml-0"
            >{{ $t('requests.consult') }}</sp-button>
          </div>
        </div>
      </div>
      <p
        v-if="PrelabelData.application.label_ref==null && PrelabelData.application.request_label_date !=null && PrelabelData.application.request_status == '2'"
        class="text-red my-6 leading-loose font-semibold px-4 py-2 m-2"
      >Votre demande de passage de pré-label à Label est acceptée.</p>
      <p
        v-else-if="PrelabelData.application.label_ref==null && PrelabelData.application.request_label_date !=null && PrelabelData.application.request_status == '4'"
        class="text-red my-6 leading-loose font-semibold px-4 py-2 m-2"
      >Votre demande de passage de pré-label à Label est en attente de complément.</p>
      <p
        v-else-if="PrelabelData.application.label_ref==null && PrelabelData.application.request_label_date !=null"
        class="text-red my-6 leading-loose font-semibold px-4 py-2 m-2"
      >Votre demande de passage de pré-label à Label est en cours d'instruction.</p>
      <p
        v-if="PrelabelData.application.label_ref==null&& PrelabelData.application.request_label_date ==null && PrelabelData.application.can_apply == true"
        class="text-red my-6 leading-loose font-semibold px-4 py-2 m-2"
      >Attention! Vous avez 6 mois à partir de la date d’obtention du Prélabel pour créer votre société et soumettre les documents nécessaires pour l’obtention du Label. Le prélabel ne vous donne accès à aucun avantage du Startup Tunisia.</p>
    </div>
    <div class="inline-flex">
      <a
        class="flex-1 px-4 py-2 m-2 font-semibold text-red no-underline hover:text-red cursor-pointer"
        @click="showAppDetailsAndRedirect()"
      >{{ $t('candidat.show_app_details') }}</a>
    </div>
  </div>
</template>

<style>
table.border-separate {
  border-spacing: 0 10px;
}

table.border-separate tbody tr {
  box-shadow: 0 2px 4px 0 rgba(29, 57, 100, 0.16);
  border-radius: 4px;
}

table.border-separate tbody tr:hover {
  box-shadow: 0 4px 8px 0 rgba(22, 66, 132, 0.19);
}

.table.border-separate tbody td {
  vertical-align: middle;
  border-color: rgba(29, 57, 100, 0.13);
}

.table.border-separate tbody tr:hover td {
  border-color: rgba(29, 57, 100, 0.23);
}

.table.border-separate thead th,
.table.border-separate thead td {
  border: none;
}
</style>

<script>
import ApiService from "@/common/api.service";
import { mapGetters, mapState } from "vuex";
import { FETCH_APPLICATION, CLEAR_SAVE_MESSAGE, STARTUP_INFORMATIONS_FORM_GET } from "@/store/actions.type";
import ButtonVue from "../../components/spKit/Button.vue";
import Link from "@/components/spKit/Link.vue";
import Loader from "@/components/Loader.vue";
import store from "@/store";
import {
  SET_LabelApp,
  SET_LabelMenuActive,
  SET_HashId,
  SET_SHOW_APP,
  SET_STARTUP_INFORMATIONS
} from "@/store/mutations.type";

export default {
  name: "request",
  components: {
    "sp-button": ButtonVue,
    "sp-link": Link,
    Loader
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(CLEAR_SAVE_MESSAGE);
    next();
  },
  data() {
    return {
      requests: null,
      checkApp: false,
      labelData: null,
      PrelabelData: null,
      loading: true
    };
  },
  mounted() {
    this.$store.commit(SET_HashId, this.$route.params.app_id);
    // Get startup information form data
    this.$store
      .dispatch(STARTUP_INFORMATIONS_FORM_GET, this.$route.params.app_id)
      .then(data => {
        if (data && data.data) {
          this.$store.commit(SET_STARTUP_INFORMATIONS, data.data.startup);
        }else{
          this.$store.commit(SET_STARTUP_INFORMATIONS, null);
        }
      })
      .catch(error => {
        this.$store.commit(SET_STARTUP_INFORMATIONS, null);
      });
    if (this.session.startup_application == null) {
      this.$store
        .dispatch(FETCH_APPLICATION, this.$route.params.app_id)
        .then(() => {
          this.checkLabel();
        })
        .catch(error => {
          this.$router.push({ name: "home" });
        });
    } else {
      this.checkLabel();
    }
  },
  methods: {
    showAppDetailsAndRedirect() {
      this.$store.commit(SET_SHOW_APP, true);
      this.$router.push({
        name: 'FormCriteria',
        params: { app_id: this.$route.params.app_id }
      });
    },
    show() {
      this.$router.push({
        name: "Prelabel",
        params: {
          id: 5,
          appHash: this.$route.params.app_id
        }
      });
    },
    edit() {
      this.$router.push({
        name: "PrelabelEdit",
        params: {
          id: 5,
          appHash: this.$route.params.app_id
        }
      });
    },
    applyRequest(id) {
      this.$router.push({
        name: "requestLabel",
        params: {
          type_id: id
        }
      });
    },
    checkLabel() {
      let application_ref = this.$route.params.app_id;
      ApiService.get(`/api/requests/check_label/${application_ref}`)
        .then(data => {
          if (data.data.data.application != null) {
            let label_ref = data.data.data.label_ref;
            this.$store.commit(SET_LabelMenuActive, 1);
            if (label_ref) {
              this.$store.commit(SET_LabelApp, label_ref);
              ApiService.get(`/api/requests/verify/${label_ref}`)
                .then(data => {
                  this.checkApp = true;
                  this.labelData = data.data;
                  this.getLabel(label_ref);
                })
                .catch(response => {
                  this.checkApp = false;
                  this.labelData = null;
                });
            } else {
              this.$store.commit(SET_LabelApp, null);
              ApiService.get(`/api/requests/verifyType/${application_ref}`)
                .then(data => {
                  this.checkApp = true;
                  this.PrelabelData = data.data.data;
                  this.loading = false;
                })
                .catch(response => {
                  this.checkApp = false;
                  this.PrelabelData = null;
                });
            }
          } else {
            this.$store.commit(SET_LabelMenuActive, 0);
          }
        })
        .catch(() => {
          this.$store.commit(SET_LabelMenuActive, 0);
          this.$router.push({
            name: "home"
          });
        });
    },
    getLabel(label_ref) {
      ApiService.get(`/api/requests/${label_ref}`)
        .then(data => {
          this.requests = data.data.data;
          this.loading = false;
        })
        .catch(response => {
          this.requests = null;
        });
    },
    isFutureDate(date) {
      const [day, month, year] = date.split('/');
      const formattedDate = new Date(`${year}-${month}-${day}`);
      formattedDate.setHours(23, 59, 0, 0); 
      return formattedDate >=  new Date();
    }
  },
  computed: {
    ...mapGetters(["session"]),
    ...mapState({
      saveMessage: state => state.request.saveMessage
    })
  }
};
</script>

<style>
</style>
